import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumEditForm1ImageConfirmPopup({
  onClose,
  onNext,
} : {
  onClose: () => void,
  onNext: () => void,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);
  const [agreement3, setAgreement3] = React.useState(false);
  const [agreement4, setAgreement4] = React.useState(false);
  const [agreement5, setAgreement5] = React.useState(false);

  return (
    <PopupContainer title="ジャケット画像に関する確認" onClose={() => { onClose(); }}>
      <div className="list__body album_delivery">
        <ul className="notes_box">
          <span className="notes red">以下すべてをお読みいただき、チェックを入れてください。</span>
        </ul>
        <dl>
          <dd>
            <CustomCheckbox checked={agreement1} setChecked={(checked) => setAgreement1(checked)}>
              この画像には文字が書かれていないか、もしくは書かれていてもその文字はアルバムタイトルやアーティスト名と一致しています。シングルの場合は曲名と一致しています。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement2} setChecked={(checked) => setAgreement2(checked)}>
              この画像は小さい写真を拡大するなどして、ぼやけた画像ではありません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement5} setChecked={(checked) => setAgreement5(checked)}>
              ︎この画像は他のリリースに使用していません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement3} setChecked={(checked) => setAgreement3(checked)}>
              ︎この画像には他者が権利を持っている画像（お店の看板、洋服や楽器やアプリのロゴ、キャラクターなど）は含まれません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement4} setChecked={(checked) => setAgreement4(checked)}>
              この画像に次のような情報は記載されていません。
              <br />
              ・アルバムタイトルやアーティスト名と異なる文字
              <br />
              ・外部への誘導となる情報（電話番号、URL、QRコード、メールアドレスなど）
              <br />
              ・販売方式を指定する語句（-EP、アルバム、CD、フリー、ストリーミング版、ステレオなど）
              <br />
              ・販売促進のための語句（期間限定、初回盤、特典付きなど）
            </CustomCheckbox>
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => { onClose(); }}>キャンセル</CustomButton>
            <CustomButton
              type="default-split"
              disabled={!(agreement1 && agreement2 && agreement3 && agreement4 && agreement5)}
              onClick={() => onNext()}
            >
              次へ
            </CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
